import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledParagraph = styled.p.withConfig({
  displayName: "Paragraph__StyledParagraph"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
export const Paragraph = _ref => {
  let {
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledParagraph, Object.assign({}, domProps, callbackProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};
Paragraph.displayName = 'Paragraph';